import {
    DELIVERY_CHALLAN_REGISTER_YARN_REPORT_REQUEST,
    DELIVERY_CHALLAN_REGISTER_YARN_REPORT_SUCCESS,
    DELIVERY_CHALLAN_REGISTER_YARN_REPORT_FAILURE,
    DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_REQUEST,
    DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_SUCCESS,
    DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_FAILURE
  } from "../types/delivery-challan-register-yarn-report-types";
  
  const initialState = {
    deliveryChallanYarnReports: {},
    loading: false,
    error: null,
  };
  
  const deliveryChallanYarnReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case DELIVERY_CHALLAN_REGISTER_YARN_REPORT_REQUEST:
      case  DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_REQUEST: {
        console.log('ent1>>11');
        
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_YARN_REPORT_SUCCESS: {
        console.log('ent1>>22');

        return {
          ...state,
          deliveryChallanRegisterYarnReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          deliveryChallanRegisterYarnFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_YARN_REPORT_FAILURE:
      case DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default deliveryChallanYarnReportReducer;
  